const mapFilterCriteria = (state) => {
    const checkboxFilters = state
        // eslint-disable-next-line no-underscore-dangle
        .filter((group) => group.__typename === 'CheckboxFilterGroup')
        .map((group) => {
        // Typecast safe because of filter step above
        const checkboxGroup = group;
        return {
            id: checkboxGroup.id,
            selectedIds: checkboxGroup.items.filter((item) => item.selected).map((item) => item.id),
        };
    })
        .filter((criteria) => criteria.selectedIds.length > 0);
    const rangeFilters = state
        // eslint-disable-next-line no-underscore-dangle
        .filter((group) => group.__typename === 'RangeFilterGroup')
        .map((group) => {
        // Typecast safe because of filter step above
        const rangeGroup = group;
        if (rangeGroup.lower !== rangeGroup.min || rangeGroup.upper !== rangeGroup.max) {
            return {
                id: rangeGroup.id,
                lower: rangeGroup.lower,
                upper: rangeGroup.upper,
            };
        }
        return null;
    })
        .filter((group) => !!group);
    const textFilter = state
        .filter((group) => group.__typename === 'TextFilter')
        .map((group) => {
        const textFiltera = group;
        return { id: textFiltera.id, value: textFiltera.value };
    });
    return Object.assign(Object.assign(Object.assign({}, (checkboxFilters.length > 0 ? { checkboxFilters } : {})), (rangeFilters.length > 0 ? { rangeFilters } : {})), (textFilter.length > 0 ? { textFilter } : {}));
};
export const mapToFilterCriteria = (state) => {
    return mapFilterCriteria(state);
};
export const mapToFlightFilterCriteria = (state) => {
    return mapFilterCriteria(state);
};
